var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('promo-section'),_c('subscr-constructor-section')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }